import type { CategoryContent } from '../row.js';

export const DRAWING_PAPER: CategoryContent = {
  bscba: [
    [
      'Welke grafiethardheid duidt op het hardste standaard tekenpotlood?',
      [
        '9H',
        '9B',
        'HB',
        '2B',
      ],
      0,
      'De H-schaal (hard) loopt van H tot 9H; B-schaal (zwart/zacht) loopt van B tot 9B. 9H is de hardste standaardgraad, die zwakke sporen achterlaat.',
    ],
    [
      'In drukwerk, wat is het bepaalde kenmerk van een reliefdruk?',
      [
        'Materiaal weghakken voor verheven inktoppervlakken',
        'Inkt wordt op een gepolijst steenoppervlak aangebracht via een chemisch proces',
        'Het beeld wordt met zuur in metaal geëtst',
        'Inkt zit in groeven die in een drukplaat zijn gesneden',
      ],
      0,
      'Reliefdruk (houtsnede, linoleumsnede) werkt door ongewenste gebieden weg te snijden, waardoor verheven oppervlakken geïnkt en afgedrukt worden.',
    ],
    [
      'Welk medium wordt gemaakt door te tekenen of te krassen op een voorbereid metalen oppervlak, meestal koper?',
      [
        'Etsing',
        'Litografie',
        'Gravering',
        'Houtsnede',
      ],
      0,
      'Etsing gebruikt zuur om in metaal in te bijten door een wasbedekte plaat; kunstenaar krast beschermlaag weg om lijnen te maken.',
    ],
    [
      'Wat is het primaire verschil tussen krijt en zacht pastel als tekenmedium?',
      [
        'Pastel heeft een bindmiddel; krijt niet',
        'Krijt is feller in kleur dan pastel',
        'Pastel kan niet op papier worden verblend',
        'Krijt wordt alleen voor onderlaag gebruikt',
      ],
      0,
      'Pastel bevat een bindmiddel (arabische gom of olie) dat pigment bij elkaar houdt; krijt is ongebonden mineraal of pigmentpoeder.',
    ],
    [
      'In zilverpoint-tekening, welk oppervlak is vereist om op te werken?',
      [
        'Papier met witte ondergrond',
        'Ruw papier, op dezelfde manier voorbereid als voor grafiet',
        'Een gewaxt metalen plaat',
        'Een gegrond houten paneel',
      ],
      0,
      'Zilverpoint vereist een voorbereide ondergrondlaag; zilver laat minuscule metaaldeeltjes na die aan het ruwe oppervlak kleven.',
    ],
    [
      'Welke druktechniek gebruikt een vlakke steen of metalen plaat waarin inkt-receptieve en inkt-afstotende gebieden naast elkaar bestaan?',
      [
        'Litografie',
        'Gravering',
        'Aquatint',
        'Houtsnede',
      ],
      0,
      'Litografie maakt gebruik van het chemische principe dat vet en water niet mengen; olie-inkt kleeft aan vette getekende gebieden en wordt door natte gebieden afgestoten.',
    ],
    [
      'Wat is waterverf in de context van tekenen?',
      [
        'Pigment gebonden met arabische gom, opgelost in water',
        'Een type grafiethoudpotlood gemengd met water',
        'Een ondoorzichtige verfsoort uitsluitend voor afgewerkte werken',
        'Een natte tekentech met inkt op ongekalanderd papier',
      ],
      0,
      'Waterverf is pigment gesuspendeerd in arabische gombinder; wordt nat aangebracht en droogt transparant, zodat papier zichtbaar blijft.',
    ],
    [
      'Wat betekent de term "voorbereide tekening" of "studie" meestal in kunstgeschiedenis?',
      [
        'Een schets gemaakt voor het eindwerk',
        'Een afgewerkte tekening bedoeld voor tentoonstellingsexposure',
        'Een kopie van het werk van een ander kunstenaar voor onderwijsdoeleinden',
        'Een tekening gemaakt nadat een beeldhouwwerk is voltooid',
      ],
      0,
      'Voorbereide tekeningen zijn werkschetsen—compositiestudies, figurenstudies of detailverkenningen gemaakt voordat het eindwerk wordt gemaakt.',
    ],
    [
      'In intagliodruktechniek, wat is het primaire onderscheid tussen etsing en gravering?',
      [
        'Etsing gebruikt zuur; gravering snijdt met de hand',
        'Gravering maakt diepere lijnen dan etsing',
        'Etsing kan alleen op koper; gravering alleen op staal',
        'Gravering vereist zuur; etsing niet',
      ],
      0,
      'Etsing gebruikt zuur om lijnen via een weerstandslaag in te bijten; gravering snijdt lijnen mechanisch met een barb of burijn-gereedschap.',
    ],
    [
      'Wat is het doel van fixatiespray toegepast op houtskool- of pasteltekeningen?',
      [
        'Om losse pigmentdeeltjes te binden en vervagen te voorkomen',
        'Om de kleuren donkerder en verzadigd te maken',
        'Om de tekening waterdicht te maken',
        'Om het papier permanent aan een houten ondergrond vast te zetten',
      ],
      0,
      'Fixatie is een dunne kleeflaag die losse deeltjes houtskool of pastel op hun plaats vastzet, waardoor vervaging wordt verminderd.',
    ],
    [
      'Welke hiervan is een handgereedschap gebruikt om tekenmedium aan te brengen of te verblenden?',
      [
        'Een verblendingsstompje',
        'Een deckle',
        'Een barb',
        'Een schaafstuk',
      ],
      0,
      'Verblendingsstompje is stijf opgerold papiergereedschap dat gebruikt wordt om houtskool, pastel of grafiet op papier te verblenden en glad te maken.',
    ],
    [
      'Wat betekent "expertise" in de context van tekenaarscollecties?',
      [
        'Deskundig oordeel bij authenticatie van kunstwerken',
        'Het proces van het inlijsten van tekeningen voor tentoonstellingsmateriaal',
        'Een formele graad in kunstgeschiedenis',
        'De restauratie en reiniging van oude tekeningen',
      ],
      0,
      'Expertise is een deskundige blik die door langdurige studie is ontwikkeld—het vermogen om toewijzing, toestand, authenticiteit en kwaliteit te beoordelen.',
    ],
    [
      'In welk medium maakte Leonardo da Vinci veel van zijn beroemde anatomische en compositie-studies?',
      [
        'Zilverpoint en krijt',
        'Alleen inkt en waterverf',
        'Grafiethoudpotlood (in moderne zin)',
        'Alleen houtskool',
      ],
      0,
      'Leonardo\'s studies combineren zilverpoint, zwart krijt, rood krijt en pen-inkt—standaardmedia voor de Renaissance-tekenpraktijk.',
    ],
    [
      'Wat is het voornaamste voordeel van het gebruik van Indische inkt in pen-en-inktekening?',
      [
        'Het is permanent, waterdicht en vervaagt niet',
        'Het is gemakkelijk wisbaar en staat correcties toe',
        'Het creëert een glanzende afwerking wanneer droog',
        'Het kan met water worden verdund om kleurverlopen te creëren',
      ],
      0,
      'Indische inkt wordt gewaardeerd vanwege permanentie en waterdichtheid; eenmaal droog, weerstaat het vlekken en degradatie.',
    ],
    [
      'Welke druktechniek gaat over het uitsnijden van een beeld in het eindkorrel van een houten blok?',
      [
        'Houtgravering',
        'Litografie',
        'Etsing',
        'Linoleumsnede',
      ],
      0,
      'Houtgravering gebruikt hard eindkorrel van buxushout; traditionele houtsnede gebruikt plankenkorrel. Eindkorrel staat fijnere details toe.',
    ],
  ],
  msc: [
    [
      'Wat is de betekenis van de "witte ondergrond"-techniek die in Old Master-tekeningen wordt gebruikt, vooral tijdens de Noord-Renaissance?',
      [
        'Een neutrale midtoon-basis voor licht en donker',
        'Het voorkwam zilverwit-oxidatie in zilverpoint-tekeningen',
        'Het was zuiver decoratief en had geen invloed op het tekenproces',
        'Het stond transparante waterverf toe boven inkt',
      ],
      0,
      'Witte ondergrond (vaak beendermeel, loodwit of krijt) gaf een stabiele basis; Old Masters exploiteerden licht, donker en middentonen in zilverpoint- en krijtstudies.',
    ],
    [
      'In etsing, wat is het technische effect van het creëren van een diepere gradering?',
      [
        'Donkerdere lijnen door meer inktretentie',
        'Lichtere lijnen, omdat diepere groeven minder inkt vasthouden',
        'Een glanzende afwerking op de afgewerkte afdruk',
        'Het vermogen om meerdere kleuren van één plaat af te drukken',
      ],
      0,
      'Diepere zuurgradering creëert bredere, diepere groeven; deze groeven houden meer inkt vast bij afvegen, waardoor donkerder, rijkere lijnen ontstaan.',
    ],
    [
      'Welke Old Master-kunstenaar staat bijzonder bekend om uitgebreide figurenstudies en anatomische tekeningen in krijt?',
      [
        'Michelangelo',
        'Rembrandt',
        'Claude Lorrain',
        'Albrecht Dürer',
      ],
      0,
      'Michelangelo\'s krijt- en houtskoolstudies—vooral spier- en figuurstudies—zijn canonieke Old Master-werken die meesterschap van vorm demonstreren.',
    ],
    [
      'Wat is de conserveringsuitdaging specifiek voor zilverpoint-tekeningen over lange periodes?',
      [
        'Zilver oxideert en verkleurt, waardoor de tekening over eeuwen donkerder wordt',
        'Voorbereide ondergrond absorbeert vochtigheid en wordt instabiel',
        'Zilver migreert in papiervezels, waardoor brosheid ontstaat',
        'Zilverpoint-tekeningen vervagen onvermijdelijk tenzij in volledige duisternis bewaard',
      ],
      0,
      'Zilverpoint oxideert vanzelf; de verkleuring verduistert de grijze lijnen, wat verklaart waarom Old Master-zilverpointtekeningen er donkerder uitzien dan toen ze werden getekend.',
    ],
    [
      'In litografie, wat is het chemische principe achter het vet-weerstandproces?',
      [
        'Vet trekt olie-inkt aan; water stoot het af',
        'Het steenoppervlak zet vet om in een waterdichte zegel',
        'Olie-inkt bindt permanent aan vet terwijl water andere deeltjes wegwast',
        'Vet dringt de steen in, waardoor het oppervlak verhardt',
      ],
      0,
      'Litografie vertrouwt op het hydrofobe-oleofiele principe: vette getekende gebieden trekken olie-inkt aan; natte gebieden (water) stoten inkt af.',
    ],
    [
      'Welke rol speelden voorbereide tekeningen in Renaissance-werkplaatspraxis?',
      [
        'Essentieel voor compositie, overdracht en training',
        'Ze werden als inferieur beschouwd en weggegooid na eindwerk',
        'Ze dienden alleen als persoonlijke schetsen die nooit werden gedeeld',
        'Ze waren verplichte voorbereidingsstadia die alle kunstenaars moesten voltooien',
      ],
      0,
      'Renaissance-werkplaatsen behandelden tekeningen als compositieblauwdrukken, leermiddelen en verslagen van artistieke ontwikkeling—integraal onderdeel van het proces.',
    ],
    [
      'Hoe verschilt aquatint in technische uitvoering van traditionele etsing?',
      [
        'Fijn harspoeder creëert gevlekte toongebieden',
        'Aquatint gebruikt vloeibare weerstand in plaats van wasgrond',
        'Aquatint is een oppervlaktetechniek zonder zuurbad',
        'Aquatint kan alleen op staalplaten; niet koper',
      ],
      0,
      'Aquatint gebruikt gegranuleerd hars om toonstructuur te creëren; zuur bijt tussen de deeltjes, waardoor een gevlekte toon ontstaat in plaats van fijne lijnen.',
    ],
    [
      'Wat is het primaire verschil tussen een verzamelaarstekening en een museumkwaliteit-tekening in termen van toestand en marktevaluatie?',
      [
        'Museumtekeningen voldoen aan strikte conserveringsnormen',
        'Verzamelaarstekeningen zijn altijd meer waard dan museumtekeningen',
        'Museumkwaliteit-tekeningen zijn nieuwer en daarom wenselijker',
        'Tekeningen van verzamelaarskwaliteit kunnen niet worden verzekerd of verkocht',
      ],
      0,
      'Museumnormen geven voorrang aan originele toestand, stabiele materialen en omkeerbare conservering; verzamelaarsstukken kunnen meer interventie verdragen.',
    ],
    [
      'In de authenticatie van Old Master-tekeningen, wat duidt "attributionele ambiguïteit" meestal aan?',
      [
        'Onzekerheid over wie het werk maakte',
        'Opzettelijke vervalsing die experts hebben afgewezen',
        'Werk dat helemaal niet ondertekend is en daarom waardeloos zou zijn',
        'Een tekening zo vakkundig gekopieerd dat de originele kunstenaar onbekend is',
      ],
      0,
      'Attributionele ambiguïteit weerspiegelt de complexiteit van de Old Master-wetenschap—gedeelde stilistische conventies, werkplaatssamenwerking en onvolledige documentatie.',
    ],
    [
      'Welk technisch voordeel bood droog-punt aan Renaissance- en latere graveurs?',
      [
        'Het creëerde een rijke, fluwelen lijn door metaalverplaatsing, zonder dat er zuur nodig was',
        'Het was sneller dan etsing en vereiste geen chemische kennis',
        'Het kon onbegrensd aantal afdrukken uit enkele plaat produceren',
        'Het stond kunstenaars toe om op zachter metaal dan traditionele gravering te werken',
      ],
      0,
      'Droge-punt gebruikt de barb (een verheven metaalkant) die ontstaat door een naald te trekken; de barb houdt extra inkt vast en produceert karakteristieke, donkere, wazige lijnen.',
    ],
    [
      'Wat is de betekenis van de "ondertekening" die in veel Old Master-schilderijen zichtbaar is onder infrarode reflectografie?',
      [
        'Het onthult verborgen voorbereidend denken',
        'Het geeft aan dat het schilderij een kopie van een eerder werk was',
        'Het bewijst dat de kunstenaar een sjabloon gebruikte voor nauwkeurigheid',
        'Het toont waar restauratoren conserveringsherstellingen hebben gemaakt',
      ],
      0,
      'Ondertekening (grafiet, krijt of inktschetsen onder de verf) onthult het artistieke proces, veranderingen van intentie en de ontwikkeling van de compositie—cruciaal voor attributie.',
    ],
    [
      'Waarom vereisen pasteltekeningen speciale archiefopslag- en monteringstechnieken?',
      [
        'Losjes gebonden pigment kan verschuiven of verblenden',
        'Pastel reageert chemisch met de meeste montagematerialen',
        'Pastel verdraagt geen vochtigheid boven 30%',
        'Pasteltekeningen vervagen spontaan zonder UV-bescherming',
      ],
      0,
      'Pasteldeeltjes worden alleen door oppervlaktefrictie en bindmiddel op hun plaats gehouden; druk, trillingen en wrijving veroorzaken pigmentverlies en verblending.',
    ],
    [
      'In connoisseurschap, wat is "pentimento" en waarom is het significant in authenticatie?',
      [
        'Een zichtbare correctie tijdens het creëren',
        'Handtekening of monogram verborgen in tekening',
        'Voorbereide techniek waar krijt in papier is gewreven',
        'Chemische marker gebruikt om oude tekeningen te dateren',
      ],
      0,
      'Pentimenti (meervoud; enkelvoud pentimento) zijn kunstenaarscorrecties zichtbaar in tekeningen—overschildering, wissen of herzien van lijnen. Duiden vaak authentiek hand-getekend werk aan.',
    ],
    [
      'Wat betekent de term "staat" met betrekking tot een gravering of etsing?',
      [
        'Elke versie van een afdruk na plaat-wijzigingen',
        'Toestand van geprinte vel wanneer van drukker aankomt',
        'Land of regio waar afdruk werd gemaakt',
        'Aantal kleuren gebruikt in afdruk',
      ],
      0,
      '"Staat" is een specifieke versie van de afdrukplaat; kunstenaars wijzigen de plaat vaak (lijnen toevoegen of verwijderen, de zuurgradering verdiepen), waardoor verschillende staten ontstaan.',
    ],
    [
      'Hoe gebruiken wetenschappers X-ray fluorescence (XRF) spectroscopie om Old Master-tekeningen te analyseren?',
      [
        'Het identificeert inkt- en pigmentcompositie',
        'Het meet dikte van papiervezel om oorsprong te bepalen',
        'Het detecteert vervalste handtekeningen door inktanalyse',
        'Het verwijdert schadelijke conserveringsbehandelingen uit tekeningen',
      ],
      0,
      'XRF is een niet-invasief analytisch instrument dat de metallische en elementaire samenstelling van media identificeert—het onthult de inktcompositie, de pigmentoorsprong en soms anachronistische materialen.',
    ],
  ],
  phd: [
    [
      'Welke structurele eigenschap van Renaissance-krijt-ondergronden, vooral met betrekking tot deeltjesgrootteverspreiding, beïnvloedde het bereik van tonen bereikt in Old Master-tekeningen?',
      [
        'Fijnere ondergronden stonden subtielere midtoon-modellering toe',
        'Groffere ondergronden absorbeerden meer water en werden voorkeur voor waterverf-overlay',
        'Deeltjesgrootte had geen gedocumenteerd effect op tekentech',
        'Fijnere ondergronden werden alleen voor onderschildering gebruikt en voor afgewerkt werk afgewezen',
      ],
      0,
      'Ondergrondcompositie beïnvloedde het tekengedrag rechtstreeks: fijner beendermeel maakte delicate lagen en subtiele modellering mogelijk; grovere ondergronden verzetten zich tegen een fijne lijndefiniëring.',
    ],
    [
      'In Rembrandts etspraktijk, wat voor technische innovatie vertegenwoordigde zijn adoptie van "oppervlak-toon"-afdrukken?',
      [
        'Ongelijk afvegen liet inktresidu achter voor toonvariatie',
        'Tweede etsnaal gebruiken om toonarcering te creëren',
        'Meerdere krijt-ondergronden toepassen voordat etsen',
        'Afdrukken op bevochtigd papier om toongradering te creëren',
      ],
      0,
      'Rembrandts oppervlaktetoon-techniek liet bij het afvegen een inktfilm op delen van de plaat achter, waardoor rijke, schilderachtige tonen ontstonden—een radicale afwijking.',
    ],
    [
      'Hoe verschilt de degradatie van ijzergal-inkt van moderne synthetische inkten in de conserveringschemie?',
      [
        'IJzergal-inkt verzuurt en verbrittelt papier over tijd',
        'IJzergal-inkt vervaagt nooit terwijl moderne inkten snel degraderen',
        'Beide inkten degraderen identiek en vereisen identieke conserveringsbehandeling',
        'Moderne inkten zijn altijd vluchtiger en vereisen donkerdere opslagcondities',
      ],
      0,
      'IJzergal-inkt ondergaat een complexe oxidatie die zwavelzuur produceert dat papiercellulose hydrolyseert; moderne inkten vermijden dit, maar kunnen fotochemische verbleking ondergaan.',
    ],
    [
      'Wat is de betekenis van "nat-op-nat"-techniek in Old Master-waterverf en hoe verhoudt het zich tot papierkalibrering?',
      [
        'Licht gekalibreerd papier staat diepere pigmentdiffusie toe',
        'Nat-op-nat vereist zware kalibrering om papierverval te voorkomen',
        'Kalibrering voorkomt de nat-op-nat-techniek en werd opzettelijk vermeden',
        'Papierkalibrering heeft geen effect op waterverf-diffusie of randkwaliteit',
      ],
      0,
      'Papierkalibrering beïnvloedt de waterabsorptie rechtstreeks: minimale kalibrering laat pigmentdiffusie en zachte overgangen toe; zware kalibrering zorgt ervoor dat het pigment op het oppervlak blijft liggen.',
    ],
    [
      'In drukwetenschap, wat onthult de term "cancellation proof" over afdruk-edities en kunstenaar-voornemen?',
      [
        'Een afdruk na opzettelijke annulering van de plaat',
        'Proefstadia voordat de finale editie werd gedrukt',
        'Fout in de editie die door de kunstenaar werd afgewezen',
        'Afdruk gemaakt tijdens het leven van de kunstenaar om de kwaliteit te verifiëren',
      ],
      0,
      'Annuleringsproeven zijn de laatste afdrukken van een vernietigde of gewijzigde plaat, historisch gebruikt om een editie definitief af te sluiten en de beperkte oplage te bewijzen.',
    ],
    [
      'Hoe evolueerde de 18e-eeuwse krijt-tekentechniek als reactie op verbeteringen in de papierproductie en de beschikbaarheid van synthetische pigmenten?',
      [
        'Beter papier en stabiele pigmenten stelden gedurfdere werken toe',
        'Synthetische pigmenten maakten krijt-tekenen verouderd',
        'Papiermakingsverbeteringen hadden geen effect op tekentech of pigmentselectie',
        'Kunstenaars verlieten krijt voor grafiet na synthetische pigmenten werden uitgevonden',
      ],
      0,
      'Verbeterde papierconsistentie en synthetische krijt- en pastelkleuren maakten grotere, kleurrijkere en ambitieuzere werken mogelijk dan eerdere praktijken—technologische verandering dreef stilistische evolutie aan.',
    ],
    [
      'Wat is het theoretische raamwerk voor "handen"-analyse in de authenticatie van Old Master-tekeningen en wat zijn de beperkingen?',
      [
        'Analyse van tekenkenmerken suggereert auteurschap, maar is niet onfeilbaar',
        '"Handen"-analyse is een definitieve wetenschappelijke methode zonder foutmarge',
        'Alleen grafiet- of inkttekeningen kunnen worden geanalyseerd door handen-authenticatie',
        'Moderne forensische technologie heeft connoisseurschap overbodig gemaakt',
      ],
      0,
      'Handen-analyse vertrouwt op gedetailleerde observatie van tekenkenmerken en stilistische eigenaardigheden, maar werkplaatsen produceerden samenwerkingswerken—daarom "attributie", geen bewijs.',
    ],
    [
      'In zilverpoint-oxidatieonderzoek, wat heeft infrarode reflectografie onthuld over visuele en materiële veranderingen in Old Master-zilverpoint gedurende 500+ jaar?',
      [
        'Verkleuring dringt door in het papier, niet alleen het oppervlak',
        'Zilverpoint oxideert nooit als het correct wordt opgeslagen',
        'Verkleuring kan volledig worden omgekeerd door moderne conserveringsmethoden',
        'Oxidatie treedt alleen op in aanwezigheid van zwavelverbindingen en is volledig te voorkomen',
      ],
      0,
      'IRR-studies tonen dat verduistering bij Old Master-zilverpoint het gevolg is van zichtbare oppervlakte- en ondergrondse oxidatie; de verkleuring is chemisch blijvend en beïnvloedt het visuele karakter van de tekening.',
    ],
    [
      'Hoe daagt het concept van "drukken als tekenen" traditionele definities uit, met name in de context van monotype?',
      [
        'Monotype vervaagt de grens tussen drukken en tekenen tot één uniek beeld',
        'Monotype is een zuiver drukproces zonder relatie tot tekenen',
        'Monotype vereist dezelfde herhaalde oplage als traditionele edities',
        'Monotype-tekeningen werden in de 20e eeuw uitgevonden',
      ],
      0,
      'Monotype is een hybride medium: de plaat is het tekenoppervlak, maar de afdruk is het kunstwerk. Er ontstaan slechts een of twee afdrukken, waardoor elke monotype bijna net zo uniek is als een handgetekend werk.',
    ],
    [
      'Welke rol speelden de anatomische tekenstudies van Michelangelo in de Renaissance-theorie van disegno en hoe beïnvloedde dit illustraties in drukwerk?',
      [
        'Zijn afdrukken maakten anatomie centraal in academisch onderwijs',
        'Michelangelo had geen invloed op druk-praktijk',
        'Anatomische studies werden irrelevant voor drukken beschouwd',
        'Renaissance-kunstenaars vermeden anatomie in hun gepubliceerde werken',
      ],
      0,
      'Michelangelo\'s anatomische studies (en de verspreiding ervan via afdrukken) maakten anatomie centraal in de kunstopleiding en het onderwijs in drukkunst—tekenen werd de grondslag van alle beeldende kunsten.',
    ],
    [
      'In conserveringswetenschap, wat is de "bruine reactie" in ijzergal-inkt en hoe verhoudt het zich tot ligninegehalte in papier?',
      [
        'Ijzersulfaat katalyseert lignine-oxidatie in papier',
        'Bruining is een zuiver oppervlaktefenomeen, onafhankelijk van de papierchemie',
        'Alleen moderne papiersoorten ondergaan bruining; oude papieren zijn resistent',
        'Bruining treedt alleen op wanneer tekeningen aan licht worden blootgesteld',
      ],
      0,
      'Papierbruining door ijzergal-inkt impliceert zuurkatalyse van lignine-oxidatie. Zuurvrij papier weerstaat dit; papier met een hoog ligninegehalte (gebruikelijk in oude tekeningen) lijdt aan systematische verduistering.',
    ],
    [
      'Wat betekent de term "reproductiegravure" in kunsthistorische context en waarom herschikte de teruggang ervan na 1870 de markt voor originele tekeningen?',
      [
        'Vaardige kopieën voor massadistributie, vervangen door fotografie',
        'Reproductie-graverijen waren voornaamste bron van artistiek inkomen',
        'Fotografie maakte originele tekeningen minder waardevol',
        'Reproductie-graverijen zijn nog steeds dominante druktech',
      ],
      0,
      'Massaproductiemethoden verdrongen reproductiegraveringen tegen 1900, wat paradoxaal genoeg de verzamelaarsbelangstelling voor originele tekeningen en afdrukken verhoogde. De verschuiving van reproductie naar origineel kunstwerk dreef de moderne verzamelcultuur aan.',
    ],
    [
      'Hoe verhouden wetenschappelijke debatten over Michelangelo\'s rode-krijt-tekentechniek zich tot debatten over de toegankelijkheid van rood krijt in Florence in de jaren 1510?',
      [
        'Rode-krijt-zeldzaamheid informeert attributie',
        'Rode-krijt-aanbod had geen effect op tekenpraxis',
        'Alle Old Masters gebruikten rode-krijt gelijk',
        'Michelangelo gebruikte exclusief zwart-krijt',
      ],
      0,
      'De schaarste en beschikbaarheid van rood krijt in het Florence van de jaren 1510 maken het gebruik ervan belangrijk voor attributiestudies: een duur materiaal wijst op rechtstreeks bezit door de meester, wat het gebruik door studie-assistenten economisch beperkte.',
    ],
    [
      'In drukwetenschap, welke technische vooruitgang in staaloppervlaktetechniek transformeerde in de 19e eeuw de productie-economie van intaglio-afdrukken?',
      [
        'Staaloppervlaktebehandeling liet platen meer afdrukken doorstaan',
        'Staaloppervlaktebehandeling werd pas in de 20e eeuw uitgevonden',
        'Staaloppervlaktebehandeling verzwakte koperen platen',
        'Staaloppervlaktebehandeling had geen effect op de afdrukproductie',
      ],
      0,
      'Staaloppervlaktebehandeling (het elektrolytisch aanbrengen van een dunne laag staal op koperen platen) verlengde de levensduur van de plaat van ongeveer honderd afdrukken naar duizenden, waardoor commercieel levensvatbare grote oplages mogelijk werden.',
    ],
    [
      'Hoe hebben recente herkomst-onderzoeksmethodologieën (inclusief archief-kruisverwijzing en markt-databases) attributie-vertrouwen in tekeningen met onduidelijke eigendomsgeschiedenis verbeterd?',
      [
        'Digitale archieven helpen eigendomsgeschiedenis te herstellen',
        'Herkomst-onderzoek heeft attributie minder betrouwbaar gemaakt',
        'Digitale hulpprogramma\'s kunnen attributie-zekerheid niet verbeteren',
        'Archief-onderzoek is irrelevant voor authenticatie',
      ],
      0,
      'Moderne herkomst-databases (verkoopcatalogussen, collectie-inventarissen, gedigitaliseerde archieven) stellen onderzoekers toe eigendomsgeschiedenis te traceren en vervalsde afkomsten te detecteren.',
    ],
  ],
  professor: [
    [
      'Op welke manieren heeft recent nanotech-gebaseerd onderzoek van Old Master-papier en media het begrip van vervaardigingsprocessen en handelsnetwerken voor tekenmateriaal voor 1600 gewijzigd?',
      [
        'Nanoparticle-analyse onthult bronnen, molens en handelsroutes',
        'Nanotech heeft niet tot kunsthistorisch begrip bijgedragen',
        'Old Master-papieren en inkten kunnen niet door moderne technologie worden geanalyseerd',
        'Handelsnetwerken voor kunstmateriaal waren goed gedocumenteerd en vereisten geen nieuw onderzoek',
      ],
      0,
      'Geavanceerde microscopie en elementanalyse onthullen de vezelcompositie, de waterbronnen van papiermolens en de herkomst van inkt—dit stelt onderzoekers in staat om materiaalvoorraden, werkplaatsinkoop en geografische artistieke netwerken te reconstrueren.',
    ],
    [
      'Welke recente wetenschap betwist de attributionele stabiliteit van Rembrandts latere etsen, met name wat betreft de rol van studio-assistenten bij plaatvoorbereiding en afdrukken?',
      [
        'Onderzoekers zoals Hinterding betwisten de toeschrijving aan één enkele kunstenaar',
        'Rembrandt-werkpraktijken waren compleet decennia geleden begrepen',
        'Studio-assistenten speelden geen rol in Rembrandt\'s druk-output',
        'Moderne wetenschap heeft consensus over alle Rembrandt-etsten-authenticiteit',
      ],
      0,
      'Hedendaags onderzoek erkent dat in Rembrandts werkplaats platen gezamenlijk werden bewerkt, dat assistenten bijdroegen aan de afdrukken en dat meerdere handen betrokken waren—wat de traditionele toeschrijving aan "Rembrandt" compliceert.',
    ],
    [
      'Hoe hebben conserveringsstudies van het gebruik van doorzichtige verflagen door de Cranach-werkplaats in voorbereidende tekeningen op getint papier ons begrip van "onderschildering als eindwerk" in de Noord-Renaissance-praktijk verrijkt?',
      [
        'Cranach exploiteerde opzettelijk getinte, doorzichtige media',
        'Cranach gebruikte traditionele Old Master-technieken',
        'Getint papier had geen effect op Cranach\'s techniek',
        'Conserveringsstudies kunnen kunsthistorisch begrip niet belichten',
      ],
      0,
      'Cranachs werkplaats gebruikte opzettelijk gekleurde gronden en doorzichtige glazuren in tekeningen die als afgewerkte werken dienden. Dit vervaagde het onderscheid tussen schilderen en tekenen en onthult een geavanceerd begrip van optische effecten.',
    ],
    [
      'Op welke manieren betwist het recente heronderzoek van Leonardo\'s spiegelschrift-geschriften op tekenbladen aannames over linkshandige tekentechniek en compositieontwikkeling?',
      [
        'Druk- en arceringspatronen suggereren gemengde handigheid',
        'Leonardo\'s handigheid is goed vastgesteld zonder resterende vragen',
        'Spiegelschrift bevat geen informatie over artistieke techniek',
        'Leonardo\'s tekeningsmethoden worden volledig begrepen',
      ],
      0,
      'Analyse van spiegelschrift-drukpatronen, richting van de arcering en ruimtelijke verlopen suggereert dat Leonardo\'s compositieproces complexer was dan gewoon linkshandig tekenen—mogelijk zelfs een opzettelijke ruimtelijke codering.',
    ],
    [
      'Hoe hebben recente studies van de Japanse houtsnedetechniek en Hokusai\'s samenwerkingspraktijken in de werkplaats het westerse begrip van "auteurschap" in Old Master-afdrukken herzien?',
      [
        'Snijders, drukkers en ontwerpers werkten nauw samen',
        'Japanse afdrukken hadden geen invloed op Westerse kunstgeschiedenis',
        'Hokusai\'s techniek is irrelevant tot Westers-afdruk-begrip',
        'Auteurschap-concepten zijn stabiel gebleven over alle culturen en perioden',
      ],
      0,
      'Bij de Japanse drukmakerij waren afzonderlijke specialisten betrokken (kunstenaar, snijder, drukker, uitgever). Dit betwist westerse aannames over individueel auteurschap en onthult dat zelfs ondertekende werken op aanzienlijke samenwerking berustten.',
    ],
    [
      'Wat onthult hedendaags materieel-cultuuronderzoek naar de Old Master-tekenmarkt (1900-1945) over de rol van esthetische ideologie bij het canoniseren van bepaalde soorten tekeningen boven andere?',
      [
        'Verzamelaarsvoorkeur voor "zuivere tekening" vormde de canon',
        'Historische esthetica had geen effect op welke tekeningen werden gewaardeerd',
        'Alle Old Master-tekeningen zijn altijd gelijk gewaardeerd geweest',
        'Markt-krachten zijn irrelevant tot kunsthistorische canon-formatie',
      ],
      0,
      'Het vroegmoderne verzamelen bevoordeelde afgewerkte Old Master-tekeningen en devalueerde voorbereidend werk; deze marktgedreven canonisering blijft institutioneel bestaan en verduistert daarmee alternatieve tekentradities.',
    ],
    [
      'Hoe hebben recente debatten in de conserveringsethiek over de omkeerbaarheid van eerdere interventies in Old Master-tekeningen de benadering van behandelingsbeslissingen veranderd?',
      [
        'Onomkeerbare methoden dreven de praktijk naar minimale interventie',
        'Alle conserveringsbeslissingen zijn ethisch gelijkwaardig',
        'Historische conservering was altijd optimaal',
        'Omkeerbaarheid is geen aandachtspunt binnen de conservering',
      ],
      0,
      'De realisatie dat eerder gebruikte conserveringslijmen, coatings en montages niet veilig konden worden verwijderd, heeft ethische debatten over preventie versus genezing aangewakkerd, met een voorkeur voor minimale interventie.',
    ],
    [
      'Wat onthult het opkomende vakgebied van "digitale tekeningauthenticatie", dat spectrale beeldvorming en machine learning gebruikt, over de beperkingen van menselijk connoisseurschap bij attributies met grote gevolgen?',
      [
        'Micro-patroonanalyse onthult vingerafdrukken die mensen missen',
        'Digitale methoden kunnen attributie-nauwkeurigheid niet verbeteren',
        'Connoisseurschap is altijd onfeilbaar geweest',
        'Machine learning kan artistieke stijl niet analyseren',
      ],
      0,
      'Spectrale beeldvorming en AI-patroonanalyse detecteren micro-variaties in tekenkenmerken die onzichtbaar zijn voor menselijke kenners. Soms onthullen ze vervalsers of werkplaatshanden, wat de blinde vlekken van traditionele, op het oog gebaseerde attributie aantoont.',
    ],
    [
      'Hoe hebben archiefonthullingen over 18e-eeuwse contracten van graveurs en stukloonsystemen het begrip van creatieve zelfstandigheid en economische dwang in de historische drukproductie veranderd?',
      [
        'Contracten onthullen strenge controle door opdrachtgevers achter het "genie"',
        'Economische geschiedenis is irrelevant tot afdruk-auteurschap-begrip',
        'Alle kunstenaars in geschiedenis genoten volledige creatieve vrijheid',
        'Werkplaats-contracten vertellen ons niets over werkelijke creatieve praktijk',
      ],
      0,
      'Historische contracten documenteren strikte controle door opdrachtgevers, beperkingen door stukloon en dwingende ontwerpeisen. Dit onthult dat veel gevierde afdrukken beperkte opdrachten waren, geen vrije creatieve expressie.',
    ],
    [
      'Welk recent onderzoek naar de chemische degradatie van waterverfpigmenten, met name synthetische anilinekleurstoffen in 19e-eeuwse tekeningen, betwist conserveringsaannames over UV-lichtblootstelling?',
      [
        'Anilijn-kleurstoffen degraderen door ozon, niet alleen licht',
        'Waterverf-pigmenten vervagen nooit in donkere opslag',
        'UV-licht is enige verval-oorzaak',
        'Synthetische kleurstoffen zijn stabieler dan natuurlijke pigmenten',
      ],
      0,
      'Onderzoek toont dat de degradatie van anilinekleurstoffen deels het gevolg is van atmosferische ozon- en SO₂-oxidatie, en niet alleen van licht. Dit verschuift de conserveringsprioriteiten van uitsluitend lichtcontrole naar een breder omgevingsbeheer.',
    ],
    [
      'Hoe herschrijft de recente ontdekking van verborgen inscripties (gedetecteerd via infrarood en röntgenfotografie) in Michelangelo\'s voorbereidende tekeningen de interpretatie van zijn werkmethoden en de verantwoording binnen zijn atelier?',
      [
        'Verborgen notities onthullen werkplaats-organisatie',
        'Michelangelo\'s tekeningen bevatten geen verborgen informatie',
        'Infrarood-beeldvorming heeft geen waarde voor kunsthistorisch onderzoek',
        'Verborgen inscripties zijn slechts toevallige merken',
      ],
      0,
      'IRR onthult Michelangelo\'s aantekeningen over techniek, kostenbewaking en werksessies met leerlingen—bewijs van een opzettelijke pedagogische methode en systematisering binnen de werkplaats, geen spontaan genie.',
    ],
    [
      'Wat onthult hedendaags herkomstonderzoek naar tekeningen die tijdens de Tweede Wereldoorlog werden geplunderd, over de aanhoudende institutionele aarzeling bij restitutie of erkenning van werken met een onvolledige eigendomsgeschiedenis?',
      [
        'Databases tonen houders die restitutie weigeren',
        'Alle geplunderde kunstwerken zijn succesvol teruggegeven',
        'Herkomst-onderzoek kan gestolen tekeningen niet identificeren',
        'Institutionele aarzeling tot restitutie is geen actueel probleem',
      ],
      0,
      'Databases over de herkomst van kunst uit de Tweede Wereldoorlog documenteren uitgebreide diefstal van tekeningen. Toch blijft institutionele weerstand tegen volledige verantwoording en restitutie bestaan, wat de spanning tussen historische integriteit en juridische of financiële belangen blootlegt.',
    ],
    [
      'Hoe hebben recente studies van de drukmatrices van Dürers werkplaats (houtblokken en koperen platen), waarbij niet-destructieve 3D-scanning wordt gebruikt, het begrip van plaatrevisie, hergebruik en gedeeld auteurschap veranderd?',
      [
        '3D-mapping toont decennia van plaat-revisie en hergebruik',
        'Dürer\'s platen werden nooit herzien of gewijzigd',
        '3D-scanning kan informatie over druk-matrices niet verstrekken',
        'Alle Dürer-afdrukken werden zonder revisie gecreëerd',
      ],
      0,
      '3D-matrixanalyse onthult systematische revisie, overwerking en hergebruik gedurende decennia—bewijs van een iteratieve manier van samenwerken en voortdurende inzet binnen de werkplaats, niet van eenmalige creatie.',
    ],
    [
      'Welk recent theoretisch werk in de visuele cultuurstudies betwist de westerse metafoor van "tekenen als transcriptie van het zien" door vergelijking met Chinese literaire tekentradities?',
      [
        'Cahill: literair tekenen drukt ideeën uit, geen gelijkenis',
        'Alle teken-tradities delen identieke doeleinden',
        'Westerse en Chinese teken zijn niet vergelijkbaar',
        'Cultuur-studies zijn irrelevant tot kunsthistorisch onderzoek',
      ],
      0,
      'Chinees literair tekenen streeft naar filosofische en conceptuele expressie, niet naar optische getrouwheid—dit onthult dat "tekenen als transcriptie van het zien" een westerse aanname is, geen universele categorie.',
    ],
    [
      'Hoe heeft in de drukconserveringsethiek de opkomst van "omkeerbare verandering" als standaard oudere conserveringsbeslissingen ter discussie gesteld die esthetische "verbetering" boven historische nauwkeurigheid stelden?',
      [
        'Nieuwe standaarden stellen oude agressieve ingrepen ter discussie',
        'Alle conserveringsbeslissingen zijn ethisch gelijkwaardig',
        'Historische conservering was altijd optimaal',
        'Omkeerbaarheid is geen aandachtspunt binnen de conservering',
      ],
      0,
      'De ethiek van omkeerbaarheid stelt eerdere agressieve reiniging en "verbetering" ter discussie—dit onthult dat esthetische verhoging vaak de historische authenticiteit vernietigde. Moderne conservering geeft voorrang aan het behoud van bewijs boven schijnbaar herstel.',
    ],
  ],
};
